import { render, staticRenderFns } from "./AgendamentosCard.vue?vue&type=template&id=72a9c112&scoped=true"
import script from "./AgendamentosCard.vue?vue&type=script&lang=js"
export * from "./AgendamentosCard.vue?vue&type=script&lang=js"
import style0 from "./AgendamentosCard.vue?vue&type=style&index=0&id=72a9c112&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a9c112",
  null
  
)

export default component.exports